module.exports = __webpack_public_path__ + "static/media/flag.58f0edde.svg";